var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg008SignForm1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 60 60",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "023---Sign-Form"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m13.02 6c.5522847 0 1-.44771525 1-1s-.4477153-1-1-1-1 .44771525-1 1 .4477153 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m9.02 6c.55228475 0 1-.44771525 1-1s-.44771525-1-1-1-1 .44771525-1 1 .44771525 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m5.02 6c.55228475 0 1-.44771525 1-1s-.44771525-1-1-1-1 .44771525-1 1 .44771525 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m55 0h-50c-2.76005315.00330612-4.99669388 2.23994685-5 5v50c.00330612 2.7600532 2.23994685 4.9966939 5 5h50c2.7600532-.0033061 4.9966939-2.2399468 5-5v-50c-.0033061-2.76005315-2.2399468-4.99669388-5-5zm-50 2h50c1.6568542 0 3 1.34314575 3 3v3h-56v-3c0-1.65685425 1.34314575-3 3-3zm50 56h-50c-1.65685425 0-3-1.3431458-3-3v-45h56v45c0 1.6568542-1.3431458 3-3 3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m53 6c0 .55228475.4477153 1 1 1s1-.44771525 1-1c.5522847 0 1-.44771525 1-1s-.4477153-1-1-1c0-.55228475-.4477153-1-1-1s-1 .44771525-1 1c-.5522847 0-1 .44771525-1 1s.4477153 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m47 6h2c.5522847 0 1-.44771525 1-1s-.4477153-1-1-1h-2c-.5522847 0-1 .44771525-1 1s.4477153 1 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m7 21h28c1.1045695 0 2-.8954305 2-2v-4c0-1.1045695-.8954305-2-2-2h-28c-1.1045695 0-2 .8954305-2 2v4c0 1.1045695.8954305 2 2 2zm0-6h28v4h-28z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m37 24c0-.5522847-.4477153-1-1-1h-29c-.55228475 0-1 .4477153-1 1s.44771525 1 1 1h29c.5522847 0 1-.4477153 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m34 28c0-.5522847-.4477153-1-1-1h-26c-.55228475 0-1 .4477153-1 1s.44771525 1 1 1h26c.5522847 0 1-.4477153 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m32 32c0-.5522847-.4477153-1-1-1h-24c-.55228475 0-1 .4477153-1 1s.44771525 1 1 1h24c.5522847 0 1-.4477153 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m7 35c-.55228475 0-1 .4477153-1 1s.44771525 1 1 1h22c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m53 40h-9.155c14.94-28.222 9.139-17.262 10.69-20.192 1.031477-1.953105.2870211-4.3725867-1.664-5.408l-1.771-.935c-1.9509174-1.0290268-4.3666408-.2846261-5.4 1.664-15.871 29.983-12.508 23.621-13.17 24.871h-25.53c-1.1045695 0-2 .8954305-2 2v12c0 1.1045695.8954305 2 2 2h46c1.1045695 0 2-.8954305 2-2v-12c0-1.1045695-.8954305-2-2-2zm-9.279-16.865 1.768.936-9.395 17.747c-.6526461-.2293868-1.3288167-.3853487-2.016-.465zm1.872-3.535 5.3 2.807-.936 1.768-5.3-2.807zm-12.167 23.672c.9209331.0732259 1.8207225.3141864 2.655.711.7963349.4661886 1.5006079 1.0742087 2.078 1.794l-5.5 4.663zm5.954.888c-.4526132-.5235599-.9620815-.9951283-1.519-1.406l9.4-17.747 1.768.935c-1.329 2.493-8.329 15.724-9.649 18.218zm10.787-28.927 1.768.936c.9743131.5166796 1.3465134 1.7245413.832 2.7l-.936 1.768-5.3-2.807.935-1.768c.5177632-.9737838 1.726095-1.3446491 2.701-.829zm2.833 38.767h-46v-12h24.552c-.372 3.47.585-5.479-.88 8.229-.086814.8133315.330381 1.597556 1.0533732 1.9800834.7229921.3825274 1.6060499.2862527 2.2296268-.2430834 4.987-4.225 6.434-5.47 6.325-5.373.154-.137-.1.337 2.506-4.593h10.214z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m11 50h-2c-.55228475 0-1 .4477153-1 1s.44771525 1 1 1h2c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m17 50h-2c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h2c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m23 50h-2c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h2c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m28 50h-1c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h1c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m39 50h-1c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h1c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m42 51c0 .5522847.4477153 1 1 1h2c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-2c-.5522847 0-1 .4477153-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m49 52h2c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-2c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg008SignForm1);
export default __webpack_public_path__ + "static/media/008-sign-form-1.6edfb5da5bfd3b93a5666a2202fb1e06.svg";
export { ForwardRef as ReactComponent };